var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLoyaltySparkles = function SvgIconLoyaltySparkles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0)",
    stroke: "#061e21",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061e21",
    d: "M18.685 16.173a.376.376 0 0 1 .715 0l.672 2.017a3.01 3.01 0 0 0 1.905 1.9l2.016.672a.376.376 0 0 1 0 .714l-2.017.672a3.01 3.01 0 0 0-1.9 1.9l-.672 2.016a.376.376 0 0 1-.715 0l-.672-2.017a3.01 3.01 0 0 0-1.9-1.9l-2.025-.667a.376.376 0 0 1 0-.714l2.017-.667a3.01 3.01 0 0 0 1.9-1.9Zm-4.024-5.311a.226.226 0 0 1 .429 0l.4 1.21a1.8 1.8 0 0 0 1.146 1.143l1.21.4a.226.226 0 0 1 0 .429l-1.21.4a1.8 1.8 0 0 0-1.142 1.149l-.4 1.21a.226.226 0 0 1-.429 0l-.4-1.21a1.8 1.8 0 0 0-1.149-1.143l-1.21-.4a.226.226 0 0 1 0-.429l1.21-.4a1.8 1.8 0 0 0 1.142-1.149Zm7.363-1.093a.151.151 0 0 1 .285 0l.269.806a1.2 1.2 0 0 0 .762.762l.806.269a.151.151 0 0 1 0 .285l-.806.269a1.2 1.2 0 0 0-.762.762l-.269.806a.151.151 0 0 1-.285 0l-.269-.806a1.2 1.2 0 0 0-.762-.762l-.805-.269a.151.151 0 0 1 0-.285l.806-.269a1.2 1.2 0 0 0 .762-.762z"
  })));
};
export default SvgIconLoyaltySparkles;